// extracted by mini-css-extract-plugin
export default {"nfLoader":"AppLoader_nfLoader__hjR3r","nfLoader-spin":"AppLoader_nfLoader-spin__mJXvu"};